export default __webpack_public_path__ + "static/media/vocal_direct.f388c845.png";